// ==========================================
// SELLERMASTERLAYOUT.JSX
// 📁 File location: src/layouts/SellerMasterLayout.jsx
// ✅ Clean layout: sidebar + header + content — no gap, no conflict
// ==========================================

import React, { useState, useEffect, useContext } from 'react';
import '../assets/css/sellers/sellerlayout/sellerlayout.css';
import SellerSidebar from 'components/sellers/sellersidebar/SellersSidebar';
import SellerHeader from 'components/sellers/sellerheader/SellerHeader';
import AppContext from 'context/AppContext';

const SellerMasterLayout = ({ children, pageTitle = 'Dashboard' }) => {

  // ── Sidebar collapsed state (shared across header + content) ──
  const [isCollapsed, setIsCollapsed] = useState(false);
  const {setAuthToken,setLoggedInSeller} = useContext(AppContext);
  // ── Watch sidebar DOM for collapse class (SellerSidebar apni class khud toggle karta hai) ──
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    if (!sidebar) return;

    setIsCollapsed(sidebar.classList.contains('collapsed'));

    const observer = new MutationObserver(() => {
      setIsCollapsed(sidebar.classList.contains('collapsed'));
    });

    observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  const sidebarWidth = isCollapsed ? 72 : 280;

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    setAuthToken(authToken);
    setLoggedInSeller(JSON.parse(localStorage.getItem("loggedInSeller")));

  }, []);

  return (
    <div className="seller-layout-root">

      {/* ── Sidebar ── */}
      <SellerSidebar />

      {/* ── Right side: header + content ── */}
      <div
        className="seller-layout-main"
        style={{
          marginLeft: sidebarWidth,
          transition: 'margin-left 0.28s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        {/* ── Sticky Header ── */}
        <SellerHeader
          pageTitle={pageTitle}
          isSidebarExpanded={!isCollapsed}
        />

        {/* ── Page Content ── */}
        <main className="seller-layout-content">
          {children}
        </main>
      </div>

    </div>
  );
};

export default SellerMasterLayout;
